import * as React from 'react';
import {
    Box,
} from "@mui/material";
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {updatePlanning} from "../../actions/planning";
import { ReactComponent as Arrow } from "../../assets/images/arrow-right.svg";
import {makeStyles} from "@mui/styles";
// import DialogManageWorkload from "./DialogManageWorkload";
import DialogChangeDetail from "../../components/planning/DialogChangeDetail";
import { ReactComponent as TrashIcon } from "../../assets/images/portfolio/trash-alt.svg";
import { ReactComponent as EditIcon } from "../../assets/images/edit.svg";

const useStyles = makeStyles({
    btn: {
        fontSize: "18px !important", 
        lineHeight:"24.59px !important",
        textDecoration: "underline !important",
        '& > svg': {
            marginLeft: "10px",
            marginBottom: "-2px",
        }
    },
    fillBlack: {
        '& > path': {
            fill: '#404349'
        },
        '& g > path': {
            fill: '#404349'
        },
    },
});

const styles = {
    td: {
        fontSize: "18px", 
        lineHeight:"24.59px",
        textDecoration: "underline",
        '& > svg': {
            marginLeft: "10px",
            marginBottom: "-2px",
        }
    },
    iconBox: {
        width: "18px",
        height: "18px",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        marginRight: "9px"
    },
};

export default function MenuPlanning2(props) {
    const classes = useStyles();
    const {data, rubricCat, itemIndex, row,add,id, onDel,onEdit} = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const dispatch = useDispatch();
    const Planning = useSelector((state) => state.Planning);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (data) => {
        setAnchorEl(null);
        if (data === "del") {
        onDel(row)
        }
    };
    const onEditPress = () => {
        const fnFindRubricCatIndex = (element) => element.rubricCat === rubricCat;
        const vRubricCatIndex = Planning.rubrics.findIndex(fnFindRubricCatIndex);
    }
    const onDeletePress = (evt) => {
        handleClose("del");
    }
    const adds = (value) => {
        add(value)
        setAnchorEl(null);
    };
    let editAcc = () => {
        setAnchorEl(null);
        onEdit();
    }
    const {t} = useTranslation()
    return (
        <div>
            <Button
                id="demo-positioned-button"
                aria-controls="demo-positioned-menu"
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                classes={{ root: classes.btn }}
            >
                {t('label.manage')} <Arrow />
            </Button>
            <Menu
                id="demo-positioned-menu"
                aria-labelledby="demo-positioned-button"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                {/*<MenuItem onClick={handleClose}>{t('label.viewDetail')}</MenuItem>*/}
                {/* <MenuItem >
                    <DialogManageWorkload type="menuText" rubricCat={rubricCat} itemIndex={itemIndex} />
                </MenuItem> */}
                <MenuItem onClick={editAcc}>
                <Box style={styles.iconBox}>
                    <EditIcon class={`${classes.fillBlack}`} />
                </Box>
                {t('label.edit')}</MenuItem>
                <MenuItem onClick={onDeletePress}>
                    <Box style={styles.iconBox} >
                        <TrashIcon/>
                    </Box>
                    {t('label.delete')}
                </MenuItem>
            </Menu>
        </div>
    );
}
